export const ANDROID_APP = 'AndroidApp';
export const BLUEFY = 'Bluefy';
export const CHROME_DESKTOP = 'Chrome desktop';
export const CHROME_MOBILE = 'Chrome mobile';
export const WEB_APP = 'WebApp';
export const WIDGET_MAC_OS_APP = 'WidgetMacOSApp';
export const WIDGET_WINDOWS_APP = 'WidgetWindowsApp';
export const EDGE_APP_GALLERY = 'Edge AppGallery';
export const EDGE_DESKTOP = 'Edge desktop';
export const EDGE_MOBILE = 'Edge mobile';
